import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import MotModal from 'Components/pages/VehicleDetailsRedesign/sections/MotSection/MotModal/MotModal';
import { VehicleSpecsDetailsButton } from 'Components/pages/VehicleDetailsRedesign/sections/MotSection/VehicleSpecsDetailsButton/VehicleSpecsDetailsButton';
import {
	triggerAdvisoryDetailsLinkClickedEvent,
	triggerAdvisoryDetailsModalClosedEvent,
} from 'Services/analytics/events';
import { MotStatus } from 'Types/motData';

import { useVehicleMainInfo } from '../../MainInfoSection/useVehicleMainInfo';
import motSectionTexts from '../MotSection.texts';
import { useVehicleMot } from '../useVehicleMot';

const localT = new MDText(motSectionTexts);

export const MOT_STATUSES_WITH_ADVISORIES = [MotStatus.Pass, MotStatus.Fail];
const STATUSES_NOT_APPLICABLE_TO_ADVISORIES = [MotStatus.Exempt, MotStatus.Unavailable];

export const MotAdvisories: React.FC = () => {
	const { make, model, prettyVrm } = useVehicleMainInfo();
	const { advisories, advisoriesAvailable, lastMotDate, motStatus } = useVehicleMot();

	const advisoriesCount = advisories.length;
	const shouldShowAdvisoriesButton =
		advisoriesCount > 0 && MOT_STATUSES_WITH_ADVISORIES.includes(motStatus as MotStatus);
	const areAdvisoriesClear = advisoriesCount === 0 && motStatus === MotStatus.Pass;

	if (!advisoriesAvailable || STATUSES_NOT_APPLICABLE_TO_ADVISORIES.includes(motStatus as MotStatus)) {
		return <>{localT.translate('fallback')}</>;
	}
	return (
		<>
			{areAdvisoriesClear ? localT.translate('allClear') : advisoriesCount}
			{shouldShowAdvisoriesButton && (
				<VehicleSpecsDetailsButton
					cypressId={cypressIds.links.motAdvisoriesDetails}
					modal={
						<MotModal
							advisories={advisories}
							advisoriesCount={advisoriesCount}
							lastMOTDate={lastMotDate}
							make={make}
							model={model}
							vrm={prettyVrm}
						/>
					}
					onModalClose={triggerAdvisoryDetailsModalClosedEvent}
					onModalOpen={triggerAdvisoryDetailsLinkClickedEvent}
				/>
			)}
		</>
	);
};
